import { render, staticRenderFns } from "./extra-email-antrag.vue?vue&type=template&id=b65e1d5c&lang=pug&"
import script from "./extra-email-antrag.vue?vue&type=script&lang=js&"
export * from "./extra-email-antrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports